import { jsx } from "react/jsx-runtime";
import React from "react";
const InitialBlockEnvironment = {
  environment: "prod"
};
const BlockEnvironmentContext = React.createContext(InitialBlockEnvironment);
const BlockEnvironmentProvider = ({
  children,
  environment
}) => {
  const value = {
    environment
  };
  return /* @__PURE__ */ jsx(BlockEnvironmentContext.Provider, { value, children });
};
const useBlockEnvironment = () => {
  return React.useContext(BlockEnvironmentContext);
};
export {
  BlockEnvironmentProvider,
  useBlockEnvironment
};
